// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.similar-results h3 {
  margin: 0 0 1.5rem 0;
  font-size: 1.3rem;
  color: #333;
}

.no-results {
  background: white;
  padding: 3rem;
  border-radius: 8px;
  text-align: center;
  color: #666;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}

.result-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.result-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.similarity-score {
  font-size: 1.25rem;
  font-weight: bold;
  color: var(--button-color, #007bff);
}

.tipo-badge {
  background: #e9ecef;
  color: #495057;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  text-transform: capitalize;
}

.result-body {
  padding: 1rem;
}

.result-body h4 {
  margin: 0 0 0.5rem 0;
  font-size: 0.95rem;
  color: #333;
  word-break: break-word;
  line-height: 1.3;
}

.result-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #666;
}

.result-actions {
  padding: 0.75rem 1rem;
  border-top: 1px solid #e9ecef;
}

.btn-view {
  width: 100%;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  background: var(--button-color, #007bff);
  color: white;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-view:hover {
  background: var(--hover-color, #0056b3);
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/SimilarResults.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC","sourcesContent":[".similar-results h3 {\n  margin: 0 0 1.5rem 0;\n  font-size: 1.3rem;\n  color: #333;\n}\n\n.no-results {\n  background: white;\n  padding: 3rem;\n  border-radius: 8px;\n  text-align: center;\n  color: #666;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.results-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n.result-card {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.result-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.result-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.similarity-score {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: var(--button-color, #007bff);\n}\n\n.tipo-badge {\n  background: #e9ecef;\n  color: #495057;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  text-transform: capitalize;\n}\n\n.result-body {\n  padding: 1rem;\n}\n\n.result-body h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.95rem;\n  color: #333;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n.result-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8rem;\n  color: #666;\n}\n\n.result-actions {\n  padding: 0.75rem 1rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.btn-view {\n  width: 100%;\n  padding: 0.5rem;\n  border: none;\n  border-radius: 4px;\n  background: var(--button-color, #007bff);\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-view:hover {\n  background: var(--hover-color, #0056b3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
